import React, {useEffect, useMemo, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import HelpSection from "./HelpSection";
import {useHistory, useLocation} from "react-router-dom";
import HelpHome from "./HelpHome";
import {NextArrow, PreviousArrow} from "../../../helpers/Icons";

const styles = {
  root: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: 0
  },
  helpNav:{
    margin: "0 auto 0 0.35rem",
    display:"flex",
    gap:"0.5rem",
    padding: "0.35rem",
    backgroundColor: "rgba(255, 255, 255, 0.66)",
    borderRadius: "4px",
  },
  navLink:{
    fontSize: "0.85rem",
    display: "flex",
    borderRadius: "4px",
    backgroundColor: "rgba(255,255,255,0.52)",
    color: "rgba(0,0,0,0.87)",
    "&:visited":{
      color: "rgba(0,0,0,0.87)"
    },
    "&:hover":{
      opacity:0.66,
    }
  }
};

const getSectionNavLinks = (viewSection, viewSectionId, orderMap, classes) => {
  let current;
  if(!viewSection || viewSectionId === "home"){
    current = 0;
  }else{
    try {
      current = parseInt(viewSectionId.substring(0, viewSectionId.indexOf(".")));
    }catch (e) {
      console.error("Invalid help id:", viewSectionId);
      current = 0;
    }
  }
  const prevOrder = current < 1 ? null : (current - 1) + ".0.0";
  const prevSection = !prevOrder ? null : orderMap[prevOrder];
  let previous = !prevSection ? null : <a key="prev" className={classes.navLink} href={`#help_${prevOrder}`}><PreviousArrow fontSize="small" /> {current - 1}. {prevSection.title}</a>;

  const nextOrder = (current + 1) + ".0.0";
  const nextSection = orderMap[nextOrder];
  const next = !nextSection ? null : <a key="next" className={classes.navLink} href={`#help_${nextOrder}`}>{current + 1}. {nextSection.title} <NextArrow fontSize="small" /></a>;
  if(viewSectionId === "home"){
    return [next];
  }
  const home = <a key="home" className={classes.navLink} href="#help_home">Help Home</a>;
  // previous = !!previous ? previous : <a key="prev" className={classes.navLink} href="#help_home"><PreviousArrow fontSize="small" /> Help Home</a>;
  return [home, previous, next]
}

function HelpDialog(props) {

  // eslint-disable-next-line
  const { helpSections, pathMap, orderMap, isOpen, setOpen, reloadHelp, addHelpEdit, isAdmin, children, classes } = props;
  const [viewSectionId, setViewSectionId] = useState(null);
  const viewSection = !!orderMap && !!viewSectionId && viewSectionId !== "home" ? orderMap[viewSectionId] : null;
  const location = useLocation();
  const history = useHistory();
  const sectionNavLinks = useMemo(() => getSectionNavLinks(viewSection, viewSectionId, orderMap, classes), [viewSection, viewSectionId, orderMap, classes])

  const setDialogOpen = (open) => {
    setOpen(open);
    if(!open && location.hash.startsWith("#help_")){
      window.location = "#close_help";
    }
  }

  useEffect(() => {
    if(location.hash === "#help_load"){
      let load = "home";
      if(location.pathname.includes("/explore/profile")){
        load = "3.0.0"
      }else if(location.pathname.includes("/explore/")){
        load = "1.0.0"
      }
      history.replace(`#help_${load}`)
    } else if(location.hash === "#close_help"){
      setDialogOpen(false);
    }  else if(location.hash === "#help_home"){
      setViewSectionId("home");
      setDialogOpen(true);
    } else {
      const m = location.hash.match(/^#help_(([0-9]+[.]?)+)$/);
      if(!m || m.length < 2){
        setDialogOpen(false);
      } else {
        const sectionNum = m[1].substring(0, m[1].indexOf(".")) + ".0.0";
        setViewSectionId(sectionNum);
        setDialogOpen(true);
      }
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [location.hash]);

  // TODO: Is an Redirect fix available so this ugly hack is not needed?
  // <Redirect> in Authentication.js causes url hash to become part of pathname instead of location.hash
  useEffect(() => {
    if(location.hash === ""){
      const h = location.pathname.indexOf("#");
      if(h > -1) {
        history.replace(location.pathname.slice(0, h))
        history.replace(location.pathname.slice(h))
      }
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [location.hash, location.pathname]);

  if(!helpSections || Object.entries(helpSections).length === 0){
    return null;
  }

  return (
    <Dialog
      style={{padding:0}}
      PaperProps={{id:"helpDialog",  style:{padding:0, margin: "8px 16px", width: "calc(100% - 32px)", maxHeight: "calc(100% - 16px)"}}}
      open={isOpen}
      fullWidth
      maxWidth="md"
      className={classes.root}
      onClose={() => setDialogOpen(false)}
    >
      <DialogContent style={{padding:0, overflowY:"visible"}}>
        {viewSectionId === "home" ?
          <HelpHome helpSections={helpSections} />
          : viewSection ?
            <HelpSection
              key={viewSection.fullOrder}
              sectionId={`${viewSection.fullOrder}.${viewSection.name}`}
              section={viewSection}
              addHelpEdit={addHelpEdit}
              currentSection={location.hash}
              isAdmin={isAdmin}
            />
            : null
        }
      </DialogContent>
      <DialogActions style={{position:'sticky', bottom:0, backgroundColor: '#fffc', zIndex: 10}}>
        <div className={classes.helpNav}>
          {sectionNavLinks}
        </div>
        {/*{location.pathname.endsWith("explore/folder/65566") ? <HelpUpdate reloadHelp={reloadHelp}/> : null}*/}
        <Button id="itemEditCancel" onClick={() => setDialogOpen(false)} variant="contained" color="secondary">
          Close
        </Button>
        {children}
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(HelpDialog);
